import React from "react";
import "./index.css";
import { t } from "i18next";

const EMAIL_REGEX = /^\S+@\S+$/;

const renderBlock = (block, index) => {
  if (Array.isArray(block)) {
    return (
      <ul className="policy-list" key={index}>
        {block.map((item, itemIndex) => (
          <li className="policy-text" key={itemIndex}>
            {item}
          </li>
        ))}
      </ul>
    );
  }

  if (block.subheading) {
    return (
      <h4 className="policy-subheading" key={index}>
        {block.subheading}
      </h4>
    );
  }

  if (EMAIL_REGEX.test(block)) {
    return (
      <p className="policy-text" key={index}>
        <a className="policy-link" href={`mailto:${block}`}>
          {block}
        </a>
      </p>
    );
  }

  return (
    <p className="policy-text" key={index}>
      {block}
    </p>
  );
};

const TermsOfUse = () => {
  const intro = t("termsOfUseIntro", { returnObjects: true });
  const sections = t("termsOfUseSections", { returnObjects: true });

  return (
    <>
      <div className="policy-hero">
        <h3 className="policy-hero-heading remove-pointer-events">
          {t("termsOfCondition")}
        </h3>
      </div>
      <div className="policy-container">
        {intro.map(renderBlock)}

        {sections.map((section, index) => (
          <React.Fragment key={index}>
            <h3 className="policy-heading">{section.heading}</h3>
            {section.content.map(renderBlock)}
          </React.Fragment>
        ))}
      </div>
      <div style={{ height: "50px" }}></div>
    </>
  );
};

export default TermsOfUse;
